var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKuroHi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(-581 -238)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "h",
    transform: "translate(581 343)",
    fontSize: 100,
    fontFamily: "Futura-Bold, Futura",
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "h")), /*#__PURE__*/React.createElement("text", {
    id: "i",
    transform: "translate(648 343)",
    fontSize: 100,
    fontFamily: "Futura-Bold, Futura",
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    id: "i-2",
    "data-name": "i",
    transform: "translate(712 265) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1,
    fontSize: 100,
    fontFamily: "Futura-Bold, Futura",
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuroHi);
export default __webpack_public_path__ + "static/media/kuroHi.6dffb2404949d76f6f16c92de289dd11.svg";
export { ForwardRef as ReactComponent };